var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h-item',{attrs:{"item":_vm.item,"count":_vm.count,"dense":_vm.dense},on:{"click":function($event){return _vm.clicked()}}}),_vm._v(" "),_c('h-modifiers',{on:{"complete":_vm.addItemWithModifiers},model:{value:(_vm.modifiers),callback:function ($$v) {_vm.modifiers=$$v},expression:"modifiers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }